import { render, staticRenderFns } from "./noticeTwo.vue?vue&type=template&id=60f8dee5&scoped=true"
import script from "./noticeTwo.vue?vue&type=script&lang=js"
export * from "./noticeTwo.vue?vue&type=script&lang=js"
import style0 from "./noticeTwo.vue?vue&type=style&index=0&id=60f8dee5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8dee5",
  null
  
)

export default component.exports